import { FormattedMessage } from "react-intl";
export function LensNameWithLensSuffix({ lensName }) {
    const hasLensSuffix = lensName.toLowerCase().endsWith(" lens");
    return hasLensSuffix ? (<>{lensName}</>) : (<FormattedMessage description="The name of the Lens with (Lens) appended" defaultMessage="{lensName} Lens" values={{
            lensName: lensName,
        }}/>);
}
